// Uygulama sabitleri
export const API_CONFIG = {
  BASE_URL: 'https://tivigo.store/endpoint.php',
  /** endpoint.php TIVIGO_ENDPOINT_LOGIN_CLIENT_KEY ile birebir aynı (sadece login) */
  LOGIN_CLIENT_KEY:
    'tivigo_ep_login_2026_a8e2c1f9b4d7e0a3c6f8b2d5e9a1c4f7b0e3d6a9c2f5b8d1e4a7c0f3b6d9e2a5c8f1b4d7e0a3c6f9b2d5e8a1c4f7b0e3d6a9c2f5b8d1e4a7c0f3b6d9e2a5c8f1b4d7e0a3c6f9b2d5e8a1c4f7b0e3d6a9c2f5b8d1e4a7c0f3b6d9e2a5c8f1b4',
  TIMEOUT: 10000,
  RETRY_ATTEMPTS: 3,
  RETRY_DELAY: 1000
};

export const UI_CONFIG = {
  ANIMATION_DELAY: 10,
  PAGE_LOADING_DELAY: 800,
  MOUNT_DELAY: 10,
  THRESHOLD: 160
};

export const SECURITY_CONFIG = {
  MIN_USERNAME_LENGTH: 3,
  MIN_PASSWORD_LENGTH: 6,
  MAX_LOGIN_ATTEMPTS: 5,
  RATE_LIMIT_WINDOW: 300000 // 5 dakika
};

export const RECAPTCHA_CONFIG = {
  V3_SITE_KEY: '6LfKf3QsAAAAAMX9JgzApavdIlkaly4j68zO6w9p',
  V2_SITE_KEY: '6LfUf3QsAAAAAGBzbiPUN9gLZNz2nsBpwtoSIbul',
  FAILED_ATTEMPTS_THRESHOLD: 3 // 3 denemeden sonra v2 göster
};

export const INTERVAL_CONFIG = {
  NOTIFICATION_CHECK: 30000, // 30 saniye
  STATS_UPDATE: 60000, // 1 dakika
  TOKEN_CHECK: 60000, // 1 dakika
  USER_DATA_UPDATE: 30000 // 30 saniye
};
